import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as jwt_decode from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AutenticaoService } from '../auth/autenticacao.service';
import { UserAuthIamService } from '../features/proof-of-life/services/user-auth-iam/user-auth-iam.service';
import User from '../features/proof-of-life/services/user-auth/User';
import { AutenticacaoRequest, AutenticacaoResponse } from '../models/autenticacao';
import { UtilAreaNaoLogada } from '../utils/configuracoes/util-area-nao-logada';
import { MockTest } from '../utils/mock-test';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
         private cookieService: CookieService,
         public router: Router,
         private autenticaoService: AutenticaoService,
         private iamService: UserAuthIamService
         ) { }

    caminhos = UtilAreaNaoLogada.caminhos();
    userData = new User({});
    autenticacaoRequest = new AutenticacaoRequest();
    autenticacaoResponse = new AutenticacaoResponse();

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
            this.verificaAutenticacao(req);

            let valor = sessionStorage.getItem('accessTokenJWT');
            const authReq = req.clone({
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + valor
                })
            });

            let decoded = jwt_decode(sessionStorage.getItem('accessTokenJWT'));
            if(decoded.authorities.toString().includes("ROLE_PERSON_VALIDATED") || decoded.authorities.toString().includes("ROLE_AUTH-STRONG")){
                return next.handle(authReq).pipe(catchError((error: any) => {
                    if (error.status == 401) {
                        this.redirectPaginaLogin(environment.urlRedirecionamento);
                    }
                    return throwError(error);
                }));
            }else{
                if(window.location.pathname.includes('relatorio-analitico')){
                    this.redirectProvaDeVida();
                }else if(!this.caminhos.includes(window.location.pathname.substr(window.location.pathname.lastIndexOf('/')))){
                    this.redirectProvaDeVida();
                }

                return next.handle(authReq).pipe(catchError((error: any) => {
                    if (error.status == 401) {
                        decoded !== null ? this.redirectProvaDeVida() : this.redirectPaginaLogin(environment.urlRedirecionamento);
                    } else {
                        //this.router.navigate(['/']);
                    }
                    return of(error);
                }));
            }
    }

    verificarStatusLogin(req: HttpRequest<any>){
            if(req.url.endsWith('/user-accounts/me') && window.location.pathname == "/prova-de-vida"){
                this.redirectPaginaLogin(environment.urlRedirecionamento);
            }
    }

    verificaAutenticacao(req: HttpRequest<any>){
        const helper = new JwtHelperService();
        const expirationDate = helper.getTokenExpirationDate(this.cookieService.get('Valgrind-AU'));
        if(expirationDate < new Date(Date.now())){
            this.cookieService.deleteAll( "/ ",  ".serasa.com.br" );
            this.cookieService.deleteAll( "/ ",  ".serasa.dev" );
        }


        if (sessionStorage.getItem('accessTokenJWT') == null) {
            if (this.cookieService.get('Valgrind-AU')) {

                this.autenticacaoRequest.token = this.cookieService.get('Valgrind-AU');

                this.autenticaoService.getAccessByClient().subscribe(res => {
                    this.autenticaoService.login(this.autenticacaoRequest, res['accessToken']).subscribe(res => {
                        this.iamService.accountData().subscribe(
                            data => {

                              if (environment.name == 'local') {
                                  let dados = MockTest.criarMockInformacaoCadastro();
                                sessionStorage.setItem("iam",JSON.stringify(MockTest.criarMockMe()))

                                sessionStorage.setItem("document",dados.document);
                                sessionStorage.setItem("email", dados.email);
                                this.iamService.dadosME.next(true);
                                this.autenticaoService.accessTokenExiste.next(true);
                                return
                              }
                                this.userData = data;
                                sessionStorage.setItem("iam", JSON.stringify(this.userData));
                                //Utilizado para gerar o protocolo do relatorio sintetico
                                sessionStorage.setItem("document", this.userData.document);
                                sessionStorage.setItem("email", this.userData.email);
                                this.iamService.dadosME.next(true);
                                this.autenticaoService.accessTokenExiste.next(true);
                            },
                            () => {
                                console.log("Erro Iam");
                            }
                        );

                        this.autenticacaoResponse = res;
                        sessionStorage.setItem('accessTokenJWT', this.autenticacaoResponse.accessToken);

                        setTimeout(() => {
                            location.reload();
                        }, 2000);
                    }, err => {
                        err.status === 401 ? this.redirectPaginaLogin(window.location.href) : this.redirectPaginaErro('2002');
                    });
                }, err => {
                    err.status === 401 ? this.redirectPaginaLogin(window.location.href) : this.redirectPaginaErro('2003');
                });
            } else {
                this.verificarStatusLogin(req);
            }
        }

    }

    redirectPaginaErro(idErro : string){
        sessionStorage.setItem("idErro", idErro);
        this.router.navigate(['/erro']);
    }

    redirectPaginaLogin(urlRedirecionamento){
        window.location.href= environment.urlPortal + "/entrar?redirectUrl=" + urlRedirecionamento;
    }
    redirectProvaDeVida(){
        this.router.navigate(['/prova-de-vida']);

    }

    redirectPaginaInicialSerasa(){
        window.location.href = environment.urlPortal;
    }

}
